import {
  cityByAirport,
  distinguishingAirportName,
  isMetroCode,
  stateByAirport,
} from '@voll-intelligence/domain';
import type { AirportNaming } from '@voll-intelligence/intelligence-ui-kit/flight-planner';
import { countryDisplayName } from '../../../shared/ui/countries.js';
import { genUiT } from '@voll-intelligence/genui-contract';

/** O que o `airportOptionOf` do kit precisa para nomear um aeroporto, no locale
 *  do host: as tabelas do domain, o nome do país e o sufixo dos códigos metro.
 *  Função pura, como o `flightPlannerCopy`: a conversa a chama com o locale do
 *  `GenUiConfig`, as páginas do web-chat com o do app, e o host memoiza por
 *  locale (o `useRecentAirports` remapeia quando a identidade muda). */
export function airportNaming(locale: string | null | undefined): AirportNaming {
  return {
    cityByAirport,
    stateByAirport,
    distinguishingAirportName,
    isMetroCode,
    countryName: (code) => countryDisplayName(code, locale),
    allAirports: genUiT(locale, 'flightPlanner.allAirports'),
  };
}
